import { string } from "prop-types";
import { useEffect, useMemo, useState } from "react";

import styled from "styled-components/macro";

import { useUserData } from "Flocknote/apiHooks";

import { INACTIVE_HEIGHT } from "CrossFeatureComponents/MemberToolbar/styleConstants";
import FnrTypography from "UI/FnrTypography";

import FnrNetworkPhoto from "UI/FnrNetworkPhoto";

import { formatPhoneNumber } from "Utilities/Number";

const InactiveState = ({ color }) => {
  const [{ fname, lname, photoUrl, emailInfo, phoneInfo }] = useUserData();
  const email = emailInfo?.email;
  const phone = phoneInfo?.phone;

  const [name, setName] = useState(`${fname || lname}`.trim());

  const displayText = useMemo(() => {
    if (name) return name;
    if (typeof email === "string") return email.split("@")[0];
    if (phone) return formatPhoneNumber(phone);
    return "(No name provided)";
  }, [email, name, phone]);

  useEffect(() => {
    if (!name) setName(`${fname || lname}`.trim());
  }, [fname, lname, name]);

  return (
    <InactiveContainer>
      <SFnrTypography bold noWrap color={color}>
        {displayText}
      </SFnrTypography>
    </InactiveContainer>
  );
};

const SFnrTypography = styled(FnrTypography)`
  transform: translateY(-0.5px);
  max-width: 80px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const InactiveContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 0px 8px;
  min-height: ${INACTIVE_HEIGHT}px;
`;

InactiveState.propTypes = { color: string };

export default InactiveState;
